<template>
  <div class="custom-control" @click="handleClick">
    <el-icon :class="topIconClass" class="icon-top">
      <CaretTop />
    </el-icon>
    <el-icon :class="bottomIconClass" class="icon-bottom">
      <CaretTop />
    </el-icon>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed } from "vue";
import { ElIcon } from "element-plus";

import { CaretTop } from "@element-plus/icons-vue";
export default defineComponent({
  components: {
    ElIcon,
    CaretTop,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const clickCount = ref(0);

    const handleClick = () => {
      clickCount.value++;

      if (clickCount.value === 1) {
        emit("update:value", "asc");
      } else if (clickCount.value === 2) {
        emit("update:value", "desc");
      } else {
        emit("update:value", "");
        clickCount.value = 0;
      }
    };

    watch(
      () => props.value,
      () => {
        if (props.value == "asc") {
          clickCount.value === 1;
        } else if (props.value == "desc") {
          clickCount.value === 2;
        } else {
          clickCount.value = 0;
        }
      }
    );

    const topIconClass = computed(() => {
      return {
        "icon-active": clickCount.value === 1,
        "icon-default": clickCount.value !== 1 && clickCount.value !== 2,
      };
    });

    const bottomIconClass = computed(() => {
      return {
        "icon-active": clickCount.value === 2,
        "icon-default": clickCount.value !== 1 && clickCount.value !== 2,
      };
    });

    return {
      handleClick,
      topIconClass,
      bottomIconClass,
    };
  },
});
</script>

<style scoped>
.custom-control {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.icon-top {
  margin: -6px 0 0;
}
.icon-bottom {
  transform: rotate(180deg);
  margin: -6px 0 0;
}

.icon-active {
  color: var(--el-color-primary);
}

.icon-default {
  color: gray;
}
</style>
